import moment from "moment-timezone";
import * as changeCase from "change-case";

import { DobJob } from "../../Services/Serverless/Lookup/Permits/OpenData/dobJobs.interface";
import { DobnowJob } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowJobs.interface";
import { DobnowLaa } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowLaa.interface";
import { DobnowElecPermit } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowElecPermits.interface";
import dobnowJobType from "./dobnowJobType";
import { DobnowAppPermit } from "../../Services/Serverless/Lookup/Permits/OpenData/dobnowAppPermits.interface";
interface DobnowJobWithKey extends DobnowJob {
  [key: string]: string;
}
export default function mergePermits({
  dobJobs,
  dobnowJobs,
  dobnowElecPermits,
  dobnowLaas,
  dobnowAppPermits,
}: {
  dobJobs: DobJob[];
  dobnowJobs: DobnowJob[];
  dobnowElecPermits: DobnowElecPermit[];
  dobnowLaas: DobnowLaa[];
  dobnowAppPermits: DobnowAppPermit[];
}) {
  const dobnowJobsWithKeys = dobnowJobs as DobnowJobWithKey[];
  const combinedPermits: {
    date: number;
    jobNo: string;
    jobType: string;
    source: string;
    status: string;
    description: string;
  }[] = [];
  dobJobs.forEach((permit) => {
    combinedPermits.push({
      date: moment(permit.latest_action_date, "MM/DD/YYYY").unix(),
      jobNo: permit.job__,
      jobType: dobnowJobType(permit.job_type),
      source: "DoB",
      status: `${permit.job_status} ${permit.job_status_descrp}`,
      description: permit.job_description,
    });
  });
  dobnowElecPermits.forEach((permit) => {
    combinedPermits.push({
      date: moment(permit.filing_date).unix(),
      jobNo: permit.job_number,
      jobType: "Electrical",
      source: "DoB Now Electrical",
      status: `${permit.filing_status}: ${permit.job_status}`,
      description: permit.job_description,
    });
  });
  dobnowJobsWithKeys.forEach((permit) => {
    const workType = Object.keys(permit)
      .filter(
        (fieldName) =>
          fieldName.match(/work_type_$/) && permit[fieldName] === "True",
      )
      .join(",")
      .replace("_work_type_", "");
    const appPermit = dobnowAppPermits.find(
      (app) => app.job_filing_number === permit.job_filing_number,
    );
    // console.log(appPermit);
    combinedPermits.push({
      date: moment(permit.current_status_date).unix(),
      jobNo: permit.job_filing_number,
      jobType: `${permit.job_type} ${workType !== "" ? `(${changeCase.capitalCase(workType)})` : ""}`,
      source: "DoB Now",
      status: `${permit.filing_status}`,
      description: appPermit ? appPermit.job_description : "",
    });
  });
  dobnowLaas.forEach((permit) => {
    combinedPermits.push({
      date: moment(permit.filing_date).unix(),
      jobNo: permit.permit_number,
      jobType: permit.work_type_name,
      source: "DoB Now Limited Alteration",
      status: `${permit.filing_status_name}`,
      description: permit.proposed_work_summary,
    });
  });
  combinedPermits.sort((a, b) => b.date - a.date);
  return combinedPermits;
}
